import http from "@/utils/request";

const orderNotifyConfigApi = {
  getAll: () =>
    http.sendRequest({
      METHOD_NAME: "orderNotifyConfig.pageQuery",
      SECURITY_TYPE: "UserLogin",
      ERROR_CODE: {}
    }),
  update: data =>
    http.sendRequest({
      METHOD_NAME: "orderNotifyConfig.update",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default orderNotifyConfigApi;
